import React, { useEffect, useState } from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '../../hooks/useTranslation'

const PracticeInterviewResponses = () => {
  const {
    interviewResponses,
    getInterviewResponses,
    filenames,
    setShowResponses,
    documentId,
    setActiveTab,
  } = usePracticeInterviewing()

  const [validVideos, setValidVideos] = useState({})

  const { t } = useTranslation('PracticeInterviewResponses')

  const fetchData = async () => {
    try {
      await getInterviewResponses(documentId)
      // console.log(decodeURIComponent(filenames.slice(-1)[0]['video']))
    } catch (error) {
      console.log(error)
    }
  }

  const checkVideoPlayable = (url) => {
    return new Promise((resolve) => {
      const video = document.createElement('video')
      video.src = url
      video.muted = true
      video.playsInline = true

      video.onloadeddata = () => resolve(true)
      video.onerror = () => resolve(false)

      // Optional: timeout in case the video never loads
      setTimeout(() => resolve(false), 8000)
    })
  }

  useEffect(() => {
    // Check all video URLs when filenames change
    filenames.forEach(async (file, idx) => {
      const url = decodeURIComponent(file['video'])
      const isValid = await checkVideoPlayable(url)
      setValidVideos((prev) => ({ ...prev, [idx]: isValid }))
      if (!isValid) {
        fetchData()
      }
    })
    // eslint-disable-next-line
  }, [filenames])

  return (
    <div className="flex flex-col">
      <h2 className="mb-4">{t('title')}</h2>
      <p className="mb-4">{t('description')}</p>
      {interviewResponses.map((response, idx) => {
        const videoUrl = decodeURIComponent(filenames[idx]['video'])
        return (
          <div key={idx} className="w-full pb-16">
            <p className="mb-4">{'Question ' + (idx + 1)}</p>
            <h2 className="mb-4">
              {response.content.customized_interview_question}
            </h2>
            <div
              id={'addpipe_response_' + response.id}
              className="addpipe_response flex w-full justify-center"
            >
              {validVideos[idx] !== false ? (
                <video
                  id={'addpipe_video_' + response.id}
                  poster={
                    decodeURIComponent(filenames[idx]['image'])
                      ? decodeURIComponent(filenames[idx]['image'])
                      : ''
                  }
                  width="500"
                  height="229"
                  controls
                  onError={() => {
                    setValidVideos((prev) => ({ ...prev, [idx]: false }))
                    fetchData()
                  }}
                >
                  <source src={videoUrl ? videoUrl : ''} type="video/mp4" />
                  {t('does_not_support')}
                </video>
              ) : (
                <div>{t('does_not_support')}</div>
              )}
            </div>
          </div>
        )
      })}
      <div className="flex w-full justify-center">
        <Button
          onClick={() => {
            setShowResponses(false)
            setActiveTab('previousPracticeInterviews')
          }}
        >
          {t('back_to_practice_interviews')}
        </Button>
      </div>
    </div>
  )
}

export default PracticeInterviewResponses
